import { Box } from "../Box/Box";

export const LeadOffsetLayout = ({ children, ...props }) => {
    return (
        <Box mb={{ xs: 6, md: 0 }} mt={-14}>
            {children}
        </Box>
    );
};
